import {lazy, Suspense, useRef, useState} from 'react'
import {Link} from '@primer/react'
import {useAnalytics} from '@github-ui/use-analytics'
import {useMergeControlInputs} from '../merge-control-context'

const CommandLineInstructionsDialog = lazy(
  () => import('../../command-line-instructions/CommandLineInstructionsDialog'),
)

export function DirectMergeInstructions() {
  const {
    baseRefName,
    canUserPushToBase,
    conflictsCondition,
    helpUrl,
    isStacked = false,
    pullRequest: {headRepository, isCrossRepo},
  } = useMergeControlInputs()

  const {sendAnalyticsEvent} = useAnalytics()
  const [isCommandLineInstructionsOpen, setIsCommandLineInstructionsOpen] = useState(false)
  const returnFocusToCommandLineInstructionsButtonRef = useRef<HTMLButtonElement | null>(null)

  if (canUserPushToBase) {
    if (isStacked) return null

    const handleOpenCommandLineInstructions = () => {
      setIsCommandLineInstructionsOpen(true)
      sendAnalyticsEvent(
        'direct_merge_section.view_command_line_instructions',
        'MERGEBOX_DIRECT_MERGE_SECTION_VIEW_COMMAND_LINE_INSTRUCTIONS_BUTTON',
      )
    }

    return (
      <>
        {isCommandLineInstructionsOpen && (
          <Suspense>
            <CommandLineInstructionsDialog
              baseRefName={baseRefName}
              conflictsCondition={conflictsCondition}
              headRepository={headRepository}
              isCrossRepo={isCrossRepo}
              returnFocusRef={returnFocusToCommandLineInstructionsButtonRef}
              onClose={() => setIsCommandLineInstructionsOpen(false)}
            />
          </Suspense>
        )}
        <span className="f6 fgColor-muted">
          You can also merge this with the command line.{' '}
          <Link
            as="button"
            ref={returnFocusToCommandLineInstructionsButtonRef}
            inline
            onClick={handleOpenCommandLineInstructions}
          >
            View command line instructions.
          </Link>
        </span>
      </>
    )
  }

  return (
    <span className="f6 fgColor-muted">
      Only those with{' '}
      <Link href={`${helpUrl}/en/get-started/learning-about-github/access-permissions-on-github`} inline>
        write access
      </Link>{' '}
      to this repository can merge pull requests.
    </span>
  )
}
